<template>
  <div id="q-app">
    <div class="whiteBorder" />
    <div class="borders" />
    <router-view v-if="!isBooting" />
  </div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';

export default {
  name: 'App',

  computed: {
    ...mapGetters('application', ['isFetchingFromAPI']),
    ...mapState('application', ['isBooting', 'language', 'validPin']),
    ...mapState('user', ['current']),
  },

  watch: {
    language() {
      this.$i18n.locale = this.language;
    },
    isFetchingFromAPI(bool) {
      if (bool) {
        this.$q.loading.show({
          spinnerSize: 64,
        });
      }
      else {
        this.$q.loading.hide();
      }
    },
  },

  async created() {
    try {
      await this.fetchAllDeliveryMethods();
      await this.fetchAllPaymentMethods();
      await this.fetchAllCategories();
      await this.fetchAllLocations();
      await this.updateCurrentUserFromStorage();
      await this.updateValidPinFromStorage();
      await this.updateLanguageFromStorage();
      await this.updateOrderLocationFromStorage();
    }
    catch (e) {
      this.$router.push({ name: 'errorNoConnection' }).catch();
    }
    finally {
      this.bootComplete();
      this.redirectUserIfLoggedIn();
    }
  },

  methods: {
    ...mapActions('category', ['fetchAllCategories']),
    ...mapActions('delivery', ['fetchAllDeliveryMethods']),
    ...mapActions('location', ['fetchAllLocations']),
    ...mapActions('payment', ['fetchAllPaymentMethods']),
    ...mapActions('application', ['updateLanguageFromStorage', 'updateValidPinFromStorage']),
    ...mapActions('user', ['updateCurrentUserFromStorage']),
    ...mapActions('order', ['updateOrderLocationFromStorage']),
    ...mapMutations('application', ['bootComplete']),

    redirectUserIfLoggedIn() {
      if (this.validPin && this.current) {
        this.$router.push('/customer').catch(() => {});
      }
    },
  },
};
</script>
